import React from 'react';
import * as Styles from './CardFeatures.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import ProTag from '../../ProTag/ProTag';
import { useResize } from '@/hooks/useResize';
import { BREAKPOINTS } from '@/pages/Studio/studio.enum';
import { IconCrown } from '../../Icons/IconCrown';

const CardFeatures = ({
  CardTitle, CardDescription, Img, imgPosition, isProPlan, showTag, onClick, creditsText,
}) => {
  const handleTagPro = showTag && !isProPlan;
  const formattedCardTitle = String(CardTitle).toLowerCase().split(' ').join('-');
  const formattedCardTestId = `feature-card-${formattedCardTitle}`;
  const windowRect = useResize();
  const { width } = windowRect;
  const smallDesktop = width < BREAKPOINTS.SMALL_DESKTOP;

  const handleOnClick = () => {
    onClick && onClick();
  };

  return (
    <Styles.CardWrapper onClick={handleOnClick} data-testid={formattedCardTestId}>
      <Styles.CardContent>
        {handleTagPro && (
          <Styles.WrapperTagPro>
            <ProTag size={!smallDesktop ? 'medium' : 'small'} />
          </Styles.WrapperTagPro>
        )}
        <Styles.WrapperTitle>
          <Styles.Title>{CardTitle}</Styles.Title>
        </Styles.WrapperTitle>
        <Styles.Description>{CardDescription}</Styles.Description>
        <Styles.CreditsTag>
          <IconCrown size="small" />
          {creditsText}
        </Styles.CreditsTag>
      </Styles.CardContent>

      <Styles.ImageWrapper>
        <Styles.Image src={Img} $imgPosition={imgPosition} alt="card" />
      </Styles.ImageWrapper>
    </Styles.CardWrapper>
  );
};
export default withErrorBoundary(CardFeatures, 'CardFeatures');
